module.exports = __webpack_public_path__ + "static/assets/89c89d8cb19c183635c7e00f2ff5a63c.svg";